"use client";

import { useEffect } from "react";

export function DynamicFavicon() {
  useEffect(() => {
    const updateFavicon = () => {
      const isDark = document.documentElement.classList.contains("dark");
      const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
      
      if (favicon) {
        favicon.href = isDark ? "/favicon-dark.png" : "/favicon-light.png";
      } else {
        const link = document.createElement("link");
        link.rel = "icon";
        link.href = isDark ? "/favicon-dark.png" : "/favicon-light.png";
        document.head.appendChild(link);
      }
    };

    // Initial check
    updateFavicon();

    // Observe changes to the 'dark' class on html
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          updateFavicon();
        }
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  return null;
}
